import React from 'react';
import { Row, Column } from '@upgrade/react-components';

import { Section, MainTitle } from '../styles';
import InfoTypes from '../InfoTypes';

import Fluid from '../../Fluid';

const FeaturesSection = ({ title, subtitle, backgroundColor, infoTypes }) => (
  <Section data-color={backgroundColor || '#ffffff'}>
    <Fluid>
      <Row xsHorizontalAlign="center">
        <Column xs={12}>
          <MainTitle as="h2">{title}</MainTitle>
          {subtitle && <p>{subtitle}</p>}
        </Column>
      </Row>
      <InfoTypes infoTypes={infoTypes} />
    </Fluid>
  </Section>
);

export default FeaturesSection;
